<template>
  <div id="app" style="transform-origin:top">

    <loading :active="loadingCounter > 0" :can-cancel="false" :is-full-page="false" />

    <template v-if="isMuted == false && isFirstInteraction">
      <div>
        <AudioClip v-if="audioState == 0 || fadeOutStorm" :autoplay="true" id="no_event_ambience" :loop="true">
        </AudioClip>
      </div>
      <div>
        <AudioClip v-if="clickCount > 0" :key="'clickCount' + clickCount" :autoplay="true" id="Transition-click">
        </AudioClip>
      </div>
      <div>
        <AudioClip v-if="powerupCount > 0" :key="'powerupCount' + powerupCount" :autoplay="true" id="powerup">
        </AudioClip>
      </div>
      <!-- landslide sound is separate -->
      <div>
        <AudioClip v-if="audioLandSlide && fadeOutStorm == false" :autoplay="true" :loop="true" :overrideVolume="1"
          id="Landslide_V0.3">
        </AudioClip>
      </div>
      <div>
        <!-- low flood -->
        <AudioClip v-if="audioState == 1 && fadeOutStorm == false" :autoplay="true" :isFadingOut="fadeOutStorm"
          id="Town Medium_V0.3" :loop="true">
        </AudioClip>
      </div>
      <div>
        <!-- high flood -->
        <AudioClip v-if="audioState == 2 && fadeOutStorm == false" :autoplay="true" :isFadingOut="fadeOutStorm"
          id="Cyclone_1" :loop="true">
        </AudioClip>
      </div>
      <div>
        <!-- cyclone -->
        <AudioClip v-if="audioState == 3 && fadeOutStorm == false" :autoplay="true" :isFadingOut="fadeOutStorm"
          id="Cyclone_2" :loop="true">
        </AudioClip>
      </div>
    </template>

    <div id="windowWrapper">
      <div id="window">

        <!-- Force load of background elements, but only from title screen -->
        <GameBackground v-if="AppState == AppStates.titleScreen" :previewMode="true" :playAudio="false">
        </GameBackground>

        <LargeBackground
          v-if="GameState != States.Game || dismissedPlayerInfo == false || dismissedBeforeYouGetStarted == false"
          :IsDark="AppState > AppStates.titleScreen"></LargeBackground>


        <TitleScreen v-if="AppState == AppStates.titleScreen" @dismiss-intro="IntroDismissed = $event"
          @play-game="DismissedTitleScreen()" :playGame="playGame" :introDismissed="IntroDismissed">
        </TitleScreen>

        <!-- @play-game="DismissedTitleScreen()" -->

        <GameMode v-else-if="AppState == AppStates.gameMode" @single-player="SinglePlayer()"
          @multi-player="Multiplayer()" @back="AppState = AppStates.titleScreen">
        </GameMode>

        <CreateOrJoinSession v-else-if="AppState == AppStates.createOrJoinSession" @create-session="createSession"
          @join-session="AppState = AppStates.joinSession" @back="AppState = AppStates.gameMode">
        </CreateOrJoinSession>

        <SessionCode v-else-if="AppState == AppStates.sessionCode" :game="game" @start-game="AppState = AppStates.game"
          @back="showQuit = true">
        </SessionCode>

        <JoinSession v-else-if="AppState == AppStates.joinSession" :playGame="playGame" :joinError="joinError"
          :game="game" @start-game="joinGame" @back="AppState = AppStates.createOrJoinSession">
        </JoinSession>

        <PlayerSelect v-else-if="GameState == States.PlayerSelect" :myUUID="myUUID" :offline="offline" :game="game"
          :isHost="isHost" @userId="p => user = p" @next-clicked="startGame()" :playGame="playGame"
          @back="backFromPlayerSelect()">
        </PlayerSelect>

        <PlayerInfo v-else-if="GameState == States.Game && dismissedPlayerInfo == false" :myUUID="myUUID"
          @continue-clicked="dismissedPlayerInfo = true" :offline="offline" :game="game" @back="showQuit = true">
        </PlayerInfo>

        <BeforeYouGetStarted v-else-if="GameState == States.Game && dismissedBeforeYouGetStarted == false"
          :myUUID="myUUID" @continue-clicked="dismissedBeforeYouGetStarted = true" @back="dismissedPlayerInfo = false"
          :game="game" @toggle-government-cheat="toggleGovernmentCheat">
        </BeforeYouGetStarted>

        <template v-else-if="GameState == States.Game">
          <MainGame :myUser="myUser" @send-message="p => sendMessage(p)" :offline="offline" :game="game"
            :messages="messages" :user="user" @request-stopbank="requestStopbank" :isHost="isHost"
            @request-nature-based-solution="requestNatureBasedSolution" @progress-game="progressGame"
            @update-game="updateGame" @river-state-cheat="riverStateCheat" @storm-state-cheat="stormStateCheat"
            @roll-dice="rollDice" :updates="mainGameUpdates" :showChat="showChat" @on-show-chat="showChat = true"
            @on-hide-chat="showChat = false" :stopBankVoteRequested="stopBankVoteRequested"
            :stopBankVoteType="stopBankVoteType" :natureBasedVoteRequested="natureBasedVoteRequested"
            :natureBasedVoteType="natureBasedVoteType"
            :hidePopups="gameOverMessage != '' && showAbout == false && showResources == false" @on-vote="OnVote"
            @on-donate="onDonate" :showStopBankResult="showStopBankResult"
            :showNatureBasedResult="showNatureBasedResult" :yesVotes="yesVotes" :noVotes="noVotes"
            @dismissed-vote-results="dimissVoteResults()" :playAudio="true" @set-default-text="setDefaultText"
            :waitingForVote="waitingForStopBankResult || waitingForNatureBasedResult" @show-about="showAbout = true"
            :newDefaultText="newDefaultText" @analytics-report="analyticsReport"
            :donation="donationReceivedList.length > 0 ? donationReceivedList[0] : null"
            @toggle-government-cheat="toggleGovernmentCheat" @dismiss-donation="dismissDonation()" :isMuted="isMuted"
            :maxHints="maxHints" :howToPlay="howToPlay" @set-how-to-play="setHowToPlay" @powerup="powerupCount++"
            :cheatEnabled="cheatEnabled">
          </MainGame>

          <div class="chat" v-if="offline == false && showChat == false" @click="showChat = !showChat"></div>
          <div class="chat-opened" v-if="offline == false && showChat == true" @click="showChat = !showChat"></div>

        </template>

        <DialogueBox v-if="showQuit" :blur="true" :left="305" :top="298" :width="671" :height="292">

          <div class="quit-container">
            <div class="quit-header" v-html="T('exit_game_header')"></div>
            <div class="quit-text" v-html="T('exit_game_text')"></div>

            <div class="quit-yes-button" @click="reloadPage">
              <div v-html="T('button_voteyes')"></div>
            </div>
            <div class="quit-no-button" @click="showQuit = false">
              <div v-html="T('button_voteno')"></div>
            </div>
          </div>

        </DialogueBox>

        <AboutBox class="force-to-front" v-else-if="showAbout" @hide-about-box="showAbout = false"></AboutBox>
        <ResourceBox class="force-to-front" v-else-if="showResources" @hide-resource-box="showResources = false">
        </ResourceBox>

        <!--gameOverMessage -->
        <DialogueBox v-else-if="gameOverMessage" :blur="true" :left="203" :top="93" :width="979" :height="651">
          <div class="game-over" v-html="gameOverHeader"></div>
          <div class="game-over-text">
            <p v-html="gameOverMessage"></p>
          </div>

          <template v-if="askForFeedback">
            <div class="game-over-feedback-prompt" v-html="T('feedback_prompt')"></div>
            <b-form-textarea class="game-over-feedback-field" v-model="feedback" rows="3" maxrows="3"
              no-resize></b-form-textarea>
          </template>

          <DashboardHeader class="game-over-dashboard-header" :myUser="myUser" :bankBalance="bankBalance"
            :ownedPropertyValue="ownedPropertyValue">
          </DashboardHeader>

          <div class="game-over-btn" @click="dismissedGameOver(false)" v-html="T('button_play_again')"></div>
          <div class="game-over-btn-2" @click="dismissedGameOver(true)" v-html="T('back_to_niwa')"></div>

          <div class="facilitator facilitator-game-over">
          </div>
          <div class="facilitator-tick facilitator-tick-game-over">
          </div>

          <AvatarCircle class="game-over-avatar-circle" :size="128" :sizeInner="96" :id="user" :showRibbon="true">
          </AvatarCircle>

          <div class="game-over-round-container">
            <div class="game-over-round-label" v-html="T('round')"></div>
            <div class="game-over-river-label" v-html="T('river')"></div>
            <div class="game-over-ocean-label" v-html="T('ocean')"></div>
            <div class="game-over-round-inner">
              <template v-for="round in gameOverRound">
                <GameOverRound v-bind:key="'gameOverRound' + round" :lastRound="round >= gameOverRound" :round="round"
                  :game="game" :playerState="playerState"></GameOverRound>
              </template>
            </div>
          </div>

        </DialogueBox>

        <div v-if="AppState != AppStates.titleScreen" class="title-btn" @click="showQuit = true"></div>
        <div class="audio-btn" :class="{ 'audio-muted': isMuted }" @click="isMuted = !isMuted"></div>
        <div class="hamburger-btn" @click="showHamburger = true"> </div>

        <div class="hamburger-menu-container" v-if="showHamburger">
          <div class="hamburger-menu">
            <div class="hamburger-menu-text-container">
              <div class="hamburger-menu-header" v-html="T('Hamburger_help')"></div>
              <div class="hamburger-menu-link-btn" v-html="T('hamburger_about')"
                @click="showHamburger = false; showAbout = true">
              </div>
              <div class="hamburger-menu-link-btn" v-if="AppState == AppStates.game && dismissedBeforeYouGetStarted"
                v-html="T('Hamburger_interface_tour')" @click="showHamburger = false; howToPlay = 0">
              </div>
              <a target="_blank" href="./files/cards.pdf" class="hamburger-menu-link-btn"
                v-html="T('Hamburger_playercards')" @click="showHamburger = false;"> </a>
              <div class="hamburger-menu-header hamburger-menu-link-btn" v-html="T('Hamburger_resources')"
                @click="showHamburger = false; showResources = true"></div>
              <div class="hamburger-menu-header-divider"></div>
              <div class="hamburger-menu-header" v-html="T('Hamburger_legal')"></div>
              <a class="hamburger-menu-link-btn" target="_blank" :href="T('Terms_Of_Use_Link')"
                v-html="T('Hamburger_terms')"></a>
              <a class="hamburger-menu-link-btn" target="_blank" :href="T('Privacy_Policy_Link')"
                v-html="T('Hamburger_privacy')"></a>
              <div class="hamburger-menu-header hamburger-menu-link-btn" v-html="T('Hamburger_exitgame')"
                @click="showHamburger = false; showQuit = true">
              </div>
            </div>
            <div class="hamburger-logo"></div>
            <div class="hamburger-close-btn" @click="showHamburger = false"></div>
          </div>
        </div>

        <ScreenTitle :game="game" :user="user" :showAvatars="showAvatars" :text="screenTitleText"></ScreenTitle>

        <div class="aspect-ratio-too-small" v-bind:key="'aspectRatioTooSmall' + mainGameUpdates"
          v-if="showAspectRatioWarning">

          <DialogueBox :notAbsolute="true" v-if="devicePixelHeight < minDevicePixelHeight" :width="800" :height="400">
            <div class="aspect-ratio-warning-container">
              <div class="aspect-ratio-warning-header" v-html="T('hey_there')">
              </div>
              <div class="aspect-ratio-warning-text" v-html="T('aspect_ratio_warning')">
              </div>
              <div class="aspect-ratio-warning-button yes-click" @click="finishedGameOver(true)"
                v-html="T('back_to_niwa')">
              </div>
              <div class="aspect-ratio-close-btn" @click="aspectRatioWarningDismissed = true"></div>
            </div>
          </DialogueBox>

          <DialogueBox :notAbsolute="true" v-else-if="aspectRatio < tallPortraitAspectRatio" :width="302" :height="567">

            <div class="aspect-ratio-warning-container">
              <div class="aspect-ratio-warning-header" v-html="T('hey_there')">
              </div>
              <div class="aspect-ratio-warning-text" v-html="T('aspect_ratio_warning')">
              </div>
              <div class="aspect-ratio-warning-button yes-click" @click="finishedGameOver(true)"
                v-html="T('back_to_niwa')">
              </div>
              <div class="aspect-ratio-close-btn" @click="aspectRatioWarningDismissed = true"></div>
            </div>
          </DialogueBox>

          <DialogueBox :notAbsolute="true" v-else-if="aspectRatio < portraitAspectRatio" :width="400" :height="600">
            <div class="aspect-ratio-warning-container">
              <div class="aspect-ratio-warning-header" v-html="T('hey_there')">
              </div>
              <div class="aspect-ratio-warning-text" v-html="T('aspect_ratio_warning')">
              </div>
              <div class="aspect-ratio-warning-button yes-click" @click="finishedGameOver(true)"
                v-html="T('back_to_niwa')">
              </div>
              <div class="aspect-ratio-close-btn" @click="aspectRatioWarningDismissed = true"></div>
            </div>
          </DialogueBox>

          <DialogueBox :notAbsolute="true" v-else :width="500" :height="400">
            <div class="aspect-ratio-warning-container">
              <div class="aspect-ratio-warning-header" v-html="T('hey_there')">
              </div>
              <div class="aspect-ratio-warning-text" v-html="T('aspect_ratio_warning')">
              </div>
              <div class="aspect-ratio-warning-button yes-click" @click="finishedGameOver(true)"
                v-html="T('back_to_niwa')">
              </div>
              <div class="aspect-ratio-close-btn" @click="aspectRatioWarningDismissed = true"></div>
            </div>
          </DialogueBox>

        </div>

      </div>


    </div>

    <div class="preload-base">
      <!-- preload certain assets so they're less likely to 'pop in'-->
      <div class="preload-rubik">.</div>
      <div class="preload-rubik preload-rubik-500">.</div>
      <div class="preload-rubik preload-rubik-700">.</div>
      <div class="preload-rubik preload-rubik-800">.</div>
      <div class="preload-rubik preload-rubik-900">.</div>
      <div class="facilitator"></div>
      <DialogueBox :left="0" :top="0" :width="0" :height="0"></DialogueBox>
    </div>

  </div>
</template>

<script lang="ts">

window.addEventListener('error', function (event) {
  alert(event.message);
  return false;
})

const maxMissedIntervals = 12; //12 missed intervals of 10 seconds = 120, two minutes
let forceError = false;
let lastWidth = "";

import Vue from 'vue';


import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import queryString from 'query-string';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Initialize Firebase
const app = initializeApp(firebaseConfig);

import { getDatabase, onValue, push, ref, set, update } from "firebase/database";

// Exports
export const database = getDatabase(app);

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

import { register } from 'vue-advanced-chat';

import PlayerSelect from './views/PlayerSelect.vue';
import MainGame from './views/MainGame.vue';
import CreateOrJoinSession from './views/CreateOrJoinSession.vue';
import SessionCode from "./views/SessionCode.vue";
import JoinSession from "./views/JoinSession.vue";
import GameMode from "./views/GameMode.vue";
import TitleScreen from "./views/TitleScreen.vue";

import PlayerInfo from "./views/PlayerInfo.vue";
import LargeBackground from "./components/LargeBackground.vue";
import AboutBox from './components/AboutBox.vue';
import DialogueBox from './components/DialogueBox.vue';
import ResourceBox from './components/ResourceBox.vue';
import DashboardHeader from './components/DashboardHeader.vue';

import GameBackground from "./components/GameBackground.vue";
import GameOverRound from "./components/GameOverRound.vue";

import VueToast from 'vue-toast-notification';
// Import one of the available themes
//import 'vue-toast-notification/dist/theme-default.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';

Vue.use(VueToast);

import axios from 'axios';
import csv from "csvtojson";

import Game, {
  NoPlayer, gamePath, getUserId, isHost, repairChat, progressGame, prepareRound,
  currentPlayer, rollRiverDice, GameCommand, GameCommandTypes,
  riverStateCheat, getUser, getRiverStage,
  gameType,
  stormStateCheat,
  getSurgeStage,
  allPlayersAtState,
  getRoundOrders
} from "../../shared_fca/game";

import { gamestates, roundstates } from '../../shared_fca/enums';
import FirebaseResult from "../../shared_fca/firebaseresponse";

import { v4 as uuidv4 } from 'uuid';
import message from '../../shared_fca/message';
import room_user, { users } from '../../shared_fca/room_user';
import playerState, { playerRPCType, playerRPC, doPlayerAction } from '../../shared_fca/playerstate';
import { getNatureBasedCost, getNatureBasedMove, getNatureBasedRaise, getStopBankCost, isInMarae, isOnFarm, ownedPropertyValue, properties, setDamageMatrix, setUpgradesMatrix, setValuesMatrix } from '../../shared_fca/property';
import { DownloadedData, DownloadedDamageMatrix, DownloadedValuesMatrix, DownloadedUpgradesMatrix } from "../../shared_fca/downloadeddata";

import "@fontsource/rubik";
import "@fontsource/rubik/500.css";
import "@fontsource/rubik/700.css";
import "@fontsource/rubik/800.css";
import "@fontsource/rubik/900.css";

export function browserUUID(): string {

  //Have we already set it?
  if (!myBrowserUUID) {

    //Try to load from local storage
    myBrowserUUID = localStorage.getItem(myBrowserUUIDKey);

    //If we can't get it from local storage, we'll generate it and save it for next time
    if (!myBrowserUUID) {
      myBrowserUUID = uuidv4();
      localStorage.setItem(myBrowserUUIDKey, myBrowserUUID);
    }

  }

  return myBrowserUUID;
}

const myBrowserUUIDKey = "myBrowserUUID";
let myBrowserUUID: string | null = null;

const analytics = new Analytics("https://asia-southeast1-geoar-analytics.cloudfunctions.net/API/", "6ac3f0ea-2e51-43c5-bb3d-a3e008de26cc", "future_coasts_aotearoa");


import { myWebWorker } from "./mywebworker.js";
import AudioClip from './components/AudioClip.vue';
import { api_Game, api_getGameId, firebaseConfig, maxRounds, upgradesURL, damageURL, valuesURL, scriptURL, referenceHeight, referenceWidth } from './configuration';
import BeforeYouGetStarted from './views/BeforeYouGetStarted.vue';
import ScreenTitle from './components/ScreenTitle.vue';
import AvatarCircle from './components/AvatarCircle.vue';
import Analytics from '../../analytics-ts/Analytics';

register();

let Dictionary: { [id: string]: string } | null = null;

const macronDictionary = {
  'ā': 'a',
  'ē': 'e',
  'ī': 'i',
  'ō': 'o',
  'ū': 'u',
}

function standardiseKey(key: string): string {
  if (!key) {
    return "";
  }

  key = key.trim().toLowerCase();

  for (const macron of Object.keys(macronDictionary)) {
    while (key.indexOf(macron) > -1) {
      key = key.replace(macron, macronDictionary[macron]);
    }
  }

  return key;
}

export function T(key: string): string {

  key = standardiseKey(key);

  if (!Dictionary) {
    return "";
  }

  if (Dictionary[key] === undefined) {
    return "Invalid key: " + key;
  }

  return Dictionary[key];
}

//Separate to the game state - this is specific to the user
enum appStates {
  titleScreen,
  gameMode,
  createOrJoinSession,
  sessionCode,
  joinSession,
  //  howToPlay, this is handled differently now
  game
}

interface voteResults {
  yesVotes: number,
  noVotes: number,
}

class appData {

  users = users;
  States = gamestates;
  AppStates = appStates;
  AppState = appStates.titleScreen;
  IntroDismissed = false;

  px_ratio = 0;
  loadingCounter = 0;
  game: Game | null = null;
  messages: message[] | null = null;
  offline = true;
  mainGameUpdates = 0;

  playGame = false;

  processedMessages: { [id: string]: boolean } = {};

  votes: { [id: string]: boolean } = {};

  stopBankVoteRequested = false;
  stopBankVoteType = 0;

  natureBasedVoteRequested = false;
  natureBasedVoteType = false;

  waitingForStopBankResult = false;
  waitingForNatureBasedResult = false;

  dismissedPlayerInfo = false;
  dismissedBeforeYouGetStarted = false;

  joinError = "";

  joinedGame = "NA";

  ImageDictionary: { [id: string]: HTMLImageElement } = {};

  gameOverHeader = "";
  gameOverMessage = "";
  askForFeedback = false;

  feedback = "";

  joinedMultiplayerGame = false;

  playerTimeoutInfo: { [id: string]: playerTimeoutInfo } = {};

  showChat = false;
  messageCount = 0;


  showStopBankResult = false;
  showNatureBasedResult = false;
  yesVotes = 0;
  noVotes = 0;

  //If we receive a donation while we're showing a notification from another player, make sure we see all of them
  donationReceivedList: playerDonation[] = [];

  showAbout = false;
  showQuit = false;
  showResources = false;

  musicKey = 0;

  isMuted = false;
  showHamburger = false;

  localRound = -1;
  newDefaultText: string[] = Array(maxRounds + 1).fill("");

  isFirstInteraction = false;
  clickCount = 0;
  powerupCount = 0;
  howToPlay = 0;

  cheatEnabled = false;

  tallPortraitAspectRatio = 768 / 1024;
  portraitAspectRatio = 1;
  tabletLandscapeAspectRatio = (1024 - 48) / 768;
  minDevicePixelHeight = 280;

  ignoreUnload = false;

  aspectRatioWarningDismissed = false;

  //iphone se = 275

}

interface playerTimeoutInfo {
  lastSeen: number; //The last reported system clock
  missed: number; //The number of times we've missed seeing the player. Should never be more than 0-1 unless the player has really left
}

export interface playerDonation {
  name: string;
  amount: number;
}

const data = new appData();

interface MessageEvent {
  detail: MessageContentDetail[]
}

interface MessageContentDetail {
  content: string;
}

AddImageToDictionary("calendar");

AddImageToDictionary("diceRiver1");
AddImageToDictionary("diceRiver2");
AddImageToDictionary("diceRiver3");

AddImageToDictionary("diceStorm1");
AddImageToDictionary("diceStorm2");
AddImageToDictionary("diceStorm4");

export function GetDynamicImage(key: string): string {
  const oldUrl = data.ImageDictionary[key].src;
  AddImageToDictionary(key);
  return oldUrl;
}

function AddImageToDictionary(key: string) {
  const image = new Image();
  image.src = process.env.BASE_URL + key + ".gif?" + Date.now();
  data.ImageDictionary[key] = image;
}

export default Vue.extend({
  name: 'App',

  components: {

    CreateOrJoinSession,
    PlayerSelect,
    MainGame,
    SessionCode,
    JoinSession,
    GameMode,
    TitleScreen,
    LargeBackground,
    PlayerInfo,
    DialogueBox,
    AudioClip,
    AboutBox,
    GameBackground,
    ResourceBox,
    DashboardHeader,
    Loading,

    //    HeaderBar,

    BeforeYouGetStarted,
    ScreenTitle,
    AvatarCircle,

    GameOverRound,

  },

  data() {
    return data;
  },

  mounted() {

    window.addEventListener('beforeunload', e => {

      if (this.ignoreUnload || this.AppState < appStates.game || this.gameOverMessage || this.showQuit) {
        return;
      }

      // Warn the user as they'll be interrupting a game in progress
      e.preventDefault();

    });

    document.onclick = (e) => {
      // eslint-disable-next-line 
      let target = e.target as any;
      this.isFirstInteraction = true;

      while (target) {


        const className = target.className.toString().toLowerCase();

        if (className.indexOf('btn') > -1 || className.indexOf('button') > -1) {
          this.clickCount++;
          return;
        }

        //Search all of the way to the top
        target = target.parentElement;
      }



    }

    if (forceError) {
      throw Error("Error test succeeded");
    }

    if (typeof Worker !== undefined) {

      window.URL = window.URL || window.webkitURL // polyfill
      // Register the web worker
      const worker = new Worker(
        window.URL.createObjectURL(myWebWorker),
      )

      // Receiving data from the Worker
      const onInterval = this.onInterval;
      worker.onmessage = function () {
        onInterval();
      }

    }

    this.px_ratio =
      window.devicePixelRatio ||
      window.screen.availWidth / document.documentElement.clientWidth;

    requestAnimationFrame(this.resized);

    this.resized();

    const parsed = queryString.parse(location.search);
    if (parsed) {

      //Are we trying to join an existing game?
      if (parsed.id) {
        this.AppState = this.AppStates.joinSession;
        this.joinGame(parsed.id as string);
      }

      //Are we trying to enable cheats?
      if (parsed.cheat) {
        this.cheatEnabled = true;
      }
    }

    let promises: Promise<void>[] = [];

    promises.push(this.DownloadPromise(scriptURL, (values: DownloadedData[]) => {
      Dictionary = {};
      for (const keyPair of values) {

        const key = standardiseKey(keyPair.UniqueID);
        if (!key) {
          continue;
        }

        if (Dictionary[key]) {
          alert("Key " + key + " is already in language dictionary!");
        }
        Dictionary[key] = keyPair.Script;
      }

    }));

    promises.push(this.DownloadPromise(damageURL, (values: DownloadedDamageMatrix[]) => {
      setDamageMatrix(values);
    }));

    promises.push(this.DownloadPromise(valuesURL, (values: DownloadedValuesMatrix[]) => {
      setValuesMatrix(values);
    }));

    promises.push(this.DownloadPromise(upgradesURL, (values: DownloadedUpgradesMatrix[]) => {
      setUpgradesMatrix(values);
    }));

    Promise.all(promises).then(() => {

      this.playGame = true;
      //this.SinglePlayer(); //TESTING
      //      this.user = "2";
      //      this.startGame();
      //      this.dismissedPlayerInfo = true;

    }).catch(() => {

      //If for some reason the download fails, refresh the page
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    });

  },

  computed: {

    showAspectRatioWarning: {
      cache: false,
      get(): boolean {

        if (this.aspectRatioWarningDismissed) {
          return false;
        }

        return this.playGame && (this.aspectRatio < this.tabletLandscapeAspectRatio || this.devicePixelHeight < this.minDevicePixelHeight);
      }
    },

    devicePixelHeight: {
      cache: false,
      get(): number {

        return window.innerHeight / window.devicePixelRatio;

        //mel 738 / 2 = 369
        //gabe 1290 / 1 = 1290
        //gabe 
      }
    },

    aspectRatio: {
      cache: false,
      get(): number {
        return window.innerWidth / window.innerHeight;
      }
    },

    gameOverRound: {
      cache: false,
      get(): number {

        const playerState = this.playerState;
        if (!playerState) {
          return 0;
        }

        return Math.min(playerState.round + 1, maxRounds);

      }
    },

    maxHints: {
      cache: false,
      get(): number {
        return this.offline ? 4 : 5;
      }
    },

    showAvatars: {
      cache: false,
      get(): boolean {

        if (this.screenTitleText || this.AppState == appStates.titleScreen) {
          return false;
        }

        const playerState = this.playerState;
        const game = this.game;

        if (!playerState || !game) {
          return false;
        }

        return playerState.roundState == roundstates.ChooseOption //If it's our turn
          //If it's not our turn, but we're not showing the round report yet
          //This should be put into a separate function!
          || (playerState.roundState == roundstates.RoundReport
            && allPlayersAtState(game, playerState.round, roundstates.RoundReport) == false)

      }
    },

    screenTitleText: {
      cache: false,
      get(): string {

        if (this.AppState == appStates.titleScreen) {
          return "";
        }

        if (this.GameState == gamestates.PlayerSelect || this.dismissedPlayerInfo == false) {
          return T("Game_Mode_Banner");
        }

        if (this.howToPlay < this.maxHints) {
          return T("button_how_to_play");
        }

        if (this.playerState && this.playerState.roundState == roundstates.Repair) {
          return T("impact_statement");
        }

        if (this.playerState && this.playerState.roundState == roundstates.Calendar) {
          return T("time_travel");
        }

        if (this.stopBankVoteRequested || this.natureBasedVoteRequested || this.showStopBankResult || this.showNatureBasedResult) {
          return T("community_poll");
        }

        return "";

      }
    },

    ownedPropertyValue: {
      cache: false,
      get(): number {
        let playerState = this.playerState;
        if (!playerState) {
          return 0;
        }
        return ownedPropertyValue(playerState);
      }
    },

    bankBalance: {
      cache: false,
      get(): number {
        let playerState = this.playerState;
        if (!playerState) {
          return 0;
        }
        return playerState.bankBalance;
      }
    },

    round: {
      cache: false,
      get(): number {
        let playerState = this.playerState;
        if (!playerState) {
          return 0;
        }
        return playerState.round;
      }
    },

    absoluteRound: {
      cache: false,
      get(): number {
        let playerState = this.playerState;
        if (!playerState) {
          return 0;
        }
        return playerState.round + 1;
      }
    },

    isMarae: {
      cache: false,
      get(): boolean {
        return isInMarae(this.playerState);
      }
    },

    isFarm: {
      cache: false,
      get(): boolean {
        return isOnFarm(this.playerState);
      }
    },

    playerState: {
      cache: false,
      get(): playerState | null {
        if (!this.game || !this.game.playerStates || !this.game.playerStates[this.user]) {
          return null;
        }
        return this.game.playerStates[this.user];
      }
    },

    fadeOutStorm: {
      cache: false,
      get(): boolean {

        let playerState = this.playerState;
        if (!playerState) {
          return false;
        }

        if (playerState.roundState == roundstates.ChooseOption || playerState.roundState == roundstates.RoundReport) {
          return true;
        }

        return false;

      }
    },

    audioLandSlide: {
      cache: false,
      get(): boolean {

        let game = this.game;
        let playerState = this.playerState;

        if (!playerState || !game) {
          return false;
        }

        const riverStage = getRiverStage(game, playerState);
        return riverStage >= 2;

      }
    },

    audioState: {
      cache: false,
      get(): number {

        let game = this.game;
        let playerState = this.playerState;

        if (!playerState || !game) {
          return 0;//-1;
        }

        const riverStage = getRiverStage(game, playerState);
        const stormStage = getSurgeStage(game, playerState);

        if (stormStage == 4) {
          //Cyclone sound
          return 3;
        }
        else if (riverStage == 2) {
          //Heavy flood sound
          return 2;
        }
        else if (riverStage > 0 || stormStage > 1) {
          return 1;
        }

        return 0;

      }
    },

    myUUID: {
      cache: false,
      get(): string {
        return browserUUID();
      }
    },

    myUser: {
      cache: false,
      get(): room_user {
        if (!this.game) {
          //Should never happen
          return users[0];
        }
        return getUser(this.game, this.myUUID);
      }
    },

    myUserId: {
      cache: false,
      get(): string {
        if (!this.game) {
          return "";
        }
        return getUserId(this.game, this.myUUID);
      }
    },

    playerViewStates: {
      cache: false,
      get(): playerViewState[] {

        let result: playerViewState[] = [];

        /*
        let maxRound = 0;

        //We want this to reflect the round state of whoever is ahead?
        if (this.game && this.game.playerStates) {
          for (const state of Object.values(this.game.playerStates)) {
            if (!state) {
              continue;
            }
            maxRound = Math.max(maxRound, state.round);
          }
        }
        */

        for (let i = 0; i < 5; i++) {

          //We want to add all five players in tutorial mode
          if (this.game && this.game.idToPlayerUUID[i] == NoPlayer) {
            continue;
          }

          result.push({
            id: i.toString(),
            //Special handling for tutorial mode
            takingTurn: this.game ? i == currentPlayer(this.game) : (i == 1)
          });

        }

        return result;
      }
    },


    isHost: {
      cache: false,
      get(): boolean {
        if (!this.game) {
          return false;
        }
        return isHost(this.game, this.myUUID, this.offline);
      }
    },

    user: {
      cache: false,
      get(): string {

        if (!this.game) {
          return "";
        }
        return getUserId(this.game, this.myUUID);

      },
      set(value: string) {

        if (!this.game) {
          return;
        }

        //Assume the player is going to just be selected
        for (const key of Object.keys(this.game.idToPlayerUUID)) {
          if (this.game.idToPlayerUUID[key] == this.myUUID) {
            this.game.idToPlayerUUID[key] = NoPlayer;
          }
        }
        this.game.idToPlayerUUID[value] = this.myUUID;

        //If we're online, also request at the server end
        if (this.offline == false) {

          this.get<boolean>(api_Game + "/" + this.game.id + "/SelectAvatar/" + value + "/" + this.myUUID, false).catch(() => {
            //ignore all errors
          });

        }
      }
    },

    GameState: {
      cache: false,
      get(): number {

        if (!this.game) {
          return gamestates.PlayerSelect;
        }

        return this.game.gamestate;


      },

      set(value: number): void {

        if (this.game && this.game.gamestate != value) {
          this.game.gamestate = value;
          this.mainGameUpdates++;
        }

      }

      /*
      set(value: number): void {
    
        if (!this.game) {
          return;
        }
    
        this.game.gamestate = value;
        //If we're online, make sure to update the game
        if (this.offline == false) {
          set(ref(database, gamePath(this.game.id) + "gamestate"), value);
        }
      },
      */

    }



  },

  methods: {

    T(key: string): string {
      return T(key);
    },

    backFromPlayerSelect() {

      if (this.isHost) {

        if (this.offline) {
          this.AppState = appStates.gameMode;
          return;
        }

        this.AppState = appStates.sessionCode;
        return;
      }

      this.showQuit = true;
    },

    setHowToPlay(newValue: number) {
      this.howToPlay = newValue;
    },

    toggleGovernmentCheat() {
      if (!this.game || !this.cheatEnabled) {
        return;
      }
      this.game.governmentSubsidy = !this.game.governmentSubsidy;
    },

    analyticsReport(actionsAvailable: string[]) {

      const game = this.game;
      const playerState = this.playerState;

      if (!game || !playerState) {
        return;
      }

      //Update these values for the start of the *next* round
      playerState.round_bankbalance[playerState.round + 1] = playerState.bankBalance;
      playerState.round_property[playerState.round + 1] = playerState.livedInProperty;
      playerState.round_propertyvalue[playerState.round + 1] = ownedPropertyValue(playerState);

      let riverStageText: string;
      switch (getRiverStage(game, playerState)) {
        case 2:
          riverStageText = "SevereFlood";
          break;
        case 1:
          riverStageText = "HighFlood";
          break;
        default:
          riverStageText = "None";
          break;
      }

      let surgeStageText: string;
      let surgeStage = getSurgeStage(game, playerState);
      if (surgeStage == 0) {
        surgeStageText = "None";
      }
      else {
        surgeStageText = "Level " + surgeStage;
      }

      let AllActions = "";
      if (playerState.roundAnalytics && playerState.roundAnalytics[playerState.round]) {
        AllActions = playerState.roundAnalytics[playerState.round].join(",");
      }

      // eslint-disable-next-line
      const data: { [id: string]: any } = {
        Player: this.myUser.analyticsId,
        FloodDice: riverStageText,
        SurgeDice: surgeStageText,
        StartOfRoundMoney: playerState.round_bankbalance[playerState.round],
        EndOfRoundMoney: playerState.round_bankbalance[playerState.round + 1],
        StartOfRoundProperty: playerState.round_property[playerState.round],
        EndOfRoundProperty: playerState.round_property[playerState.round + 1],
        StartOfRoundPropertyValue: playerState.round_propertyvalue[playerState.round],
        EndOfRoundPropertyValue: playerState.round_propertyvalue[playerState.round + 1],
        RoundOrder: getRoundOrders(game, playerState.round),
        ActionsAvailable: actionsAvailable.join(","),
        AllActions,
      };

      this.postAnalytics("Round Complete", ["Round " + (this.round + 1)], data);

    },

    dismissDonation() {
      this.donationReceivedList.shift();
    },

    dimissVoteResults() {
      this.showNatureBasedResult = this.showStopBankResult = false;
    },

    onInterval() {

      //Simply not in multiplayer mode
      if (this.joinedMultiplayerGame == false
        || !this.game
        || !this.game.playerStates) {
        return;
      }

      //Check if we've missed any other player for X number of intervals
      for (const player of Object.keys(this.game.playerStates)) {

        //We've never seen this player before?
        if (!this.playerTimeoutInfo[player]) {
          this.playerTimeoutInfo[player] = {
            missed: 0,
            lastSeen: this.game.playerStates[player].lastSeen
          }
          continue;
        }

        //We haven't had any new pings from this player        
        if (this.game.playerStates[player].lastSeen == this.playerTimeoutInfo[player].lastSeen) {
          this.playerTimeoutInfo[player].missed++;
          if (this.playerTimeoutInfo[player].missed > maxMissedIntervals) {

            const realName = T(users[parseInt(player, 10)].realname);
            this.setGameOver(T("error_lost_contact_header"), T("error_lost_contact").replace("###", realName), false);

          }

          continue;
        }

        //If we get to here, we can still see the player
        this.playerTimeoutInfo[player].missed = 0;
        this.playerTimeoutInfo[player].lastSeen = this.game.playerStates[player].lastSeen;
      }

      //Once we've checked everyone else, we need to update our OWN timeout notification
      set(ref(database, gamePath(gameType.futureCostsAotearoa, this.game.id) + "/playerStates/" + this.myUserId + "/lastSeen"), new Date().getTime());

    },

    finishedGameOver(backToNIWA: boolean) {

      this.ignoreUnload = true;

      if (backToNIWA) {
        window.location.href = "https://niwa.co.nz";
      }
      else {
        this.reloadPage();
      }

    },

    // eslint-disable-next-line
    postAnalytics(action: string, labels: string[], data: { [id: string]: any } = {}): Promise<void> {

      return new Promise((resolve) => {

        //Attach universal properties
        if (this.game) {
          data.GameID = this.game.gameUniqueId;
          data.GamePin = this.joinedGame;
        }

        analytics.Post("App", action, 0, labels, data).finally(resolve);

      })

    },

    dismissedGameOver(backToNIWA: boolean) {

      if (this.feedback) {

        this.loadingCounter++;
        this.postAnalytics("Feedback", [this.feedback]).finally(() => {
          this.finishedGameOver(backToNIWA);
        });

      }
      else {
        this.finishedGameOver(backToNIWA);
      }

    },

    reloadPage() {

      this.clearQueryString();
      location.reload();

    },

    onDonate(donateTo: { [id: string]: number } | null) {

      const playerState = this.playerState;
      if (!donateTo || !playerState) {
        return;
      }

      //Subtract the total donation cost
      for (const amount of Object.values(donateTo)) {
        playerState.bankBalance -= amount;
      }

      //Make sure analytics is set
      for (const player of Object.keys(donateTo)) {

        const analyticsKey = "Donated " + donateTo[player] + "k to " + users[parseInt(player, 10)].analyticsId;
        doPlayerAction(playerState, "", analyticsKey, maxRounds);

      }

      //Make sure that the amount is set first
      this.updateGame();

      //Send individual RPCs for each donation
      for (const player of Object.keys(donateTo)) {

        const amount = donateTo[player];
        const donationObject: playerDonation = {
          amount,
          name: T(this.myUser.realname),
        };

        this.sendRPCToPlayer(player, playerRPCType.Donate, donationObject);

      }

    },

    OnVote(vote: boolean) {

      const playerState = this.playerState;
      if (!playerState) {
        return;
      }

      let analyticsKey: string;

      if (vote) {
        analyticsKey = "Voted yes on ";
      }
      else {
        analyticsKey = "Voted no on ";
      }

      if (this.natureBasedVoteRequested) {
        if (this.natureBasedVoteType) {
          analyticsKey += " nature based (sea)";
        }
        else {
          analyticsKey += " nature based (river)";
        }
      } else {
        switch (this.stopBankVoteType) {
          case 2:
            analyticsKey += "level 2 seawall";
            break;

          case 1:
            analyticsKey += "level 1 seawall";
            break;

          default:
            analyticsKey += " stop bank";
            break;
        }
      }

      //Make sure the analytics are set first
      doPlayerAction(playerState, "", analyticsKey, maxRounds);
      this.updateGame();

      if (this.natureBasedVoteRequested) {
        this.natureBasedVoteRequested = false;
        this.waitingForNatureBasedResult = true;
        this.sendCommand(GameCommandTypes.VoteOnNatureBased, vote);
      }
      else {
        this.stopBankVoteRequested = false;
        this.waitingForStopBankResult = true;
        this.sendCommand(GameCommandTypes.VoteOnStopBank, vote);
      }

    },

    DismissedTitleScreen() {
      this.AppState = this.AppStates.gameMode;
    },

    // eslint-disable-next-line
    DownloadPromise(url: string, callback: (results: any[]) => void, retries: number = 5): Promise<void> {

      return new Promise<void>((resolve, reject) => {

        axios.get(url).then((result) => {

          return csv().fromString(result.data);

        }).then((results) => {

          callback(results);
          resolve();

        }).catch((err) => {

          if (retries <= 0) {

            reject(err);

          }
          else {

            //Wait a second before retrying
            setTimeout(() => {
              Promise.resolve(this.DownloadPromise(url, callback, retries - 1)).then(resolve).catch(reject);
            }, 1000);

          }

        })

      });

    },

    SinglePlayer() {

      this.offline = true;
      this.game = new Game("", this.myUUID);
      this.AppState = appStates.game;

    },

    Multiplayer() {

      this.offline = false;
      this.AppState = appStates.createOrJoinSession;

    },

    riverStateCheat(value: number) {
      if (!this.game || !this.cheatEnabled) {
        return;
      }

      riverStateCheat(this.game, this.round, value);
      this.updateGame();
    },

    stormStateCheat(value: number) {
      if (!this.game || !this.cheatEnabled) {
        return;
      }

      stormStateCheat(this.game, this.round, value);
      this.updateGame();
    },

    rollDice() {

      if (!this.game) {
        return;
      }

      riverStateCheat(this.game, this.round, rollRiverDice(this.round + 1));
      this.updateGame();
    },

    startGame() {

      if (!this.game) {
        return;
      }

      if (!this.game.playerStates) {
        this.game.playerStates = {};
      }

      const joinedPlayers: string[] = [];

      for (const avatarId of Object.keys(this.game.idToPlayerUUID)) {
        //This player has joined
        if (this.game.idToPlayerUUID[avatarId] != NoPlayer) {
          let user = this.users[parseInt(avatarId, 10)];
          joinedPlayers.push(user.analyticsId);
          this.game.playerStates[avatarId] = user.generatePlayerState();
        }
      }

      this.game.gamestate = gamestates.Game;
      this.updateGame(true);

      //Analytics!
      if (this.offline == false && this.isHost == false) {
        //We don't care if we're not the host
        return;
      }

      const gameStartAnalytics = {
        GovernmentSubsidy: this.game.governmentSubsidy,
        Multiplayer: this.offline == false,
        Players: joinedPlayers.join(',')
      }

      this.postAnalytics("GameStarted", ["Game Started with " + joinedPlayers.length + " player" + (joinedPlayers.length == 1 ? "" : "s")], gameStartAnalytics);

    },



    progressGame() {

      if (!this.game) {
        return;
      }

      progressGame(this.game, this.myUUID, this.offline);
      this.updateGame();

    },

    requestStopbank(seawallHeight: number) {

      if (this.offline) {
        this.stopBankVoteType = seawallHeight;
        this.stopBankEveryoneAgreed();
        this.updateGame();
        return;
      }

      this.sendCommand(GameCommandTypes.RequestVoteOnStopBank, seawallHeight);

    },

    requestNatureBasedSolution(seaVote: boolean) {

      if (this.offline) {
        this.natureBasedVoteType = seaVote;
        this.natureBasedEveryoneAgreed();
        this.updateGame();
        return;
      }

      this.sendCommand(GameCommandTypes.RequestVoteOnNatureBased, seaVote);
    },

    natureBasedEveryoneAgreed() {

      const seaVote = this.natureBasedVoteType;
      this.powerupCount++;
      let playerState = this.playerState;
      let game = this.game;

      if (!playerState || !game) {
        return;
      }

      for (const property of playerState.properties) {

        if (property.property != playerState.livedInProperty) {
          continue;
        }

        let propertyData = properties[property.property];

        playerState.bankBalance -= getNatureBasedCost(playerState, seaVote, game.governmentSubsidy);

        if (seaVote == false) {

          //Also move everything that needs to be moved
          for (let i = 0; i < propertyData.property_parts.length && i < property.propertyPartStates.length; i++) {

            let propertyPartData = propertyData.property_parts[i];
            let propertyPartState = property.propertyPartStates[i];

            //Make sure it gets raised if need be
            if (getNatureBasedMove(propertyPartData)) {
              propertyPartState.isMoving = true;
            }

            //Make sure it's raised if needed
            if (getNatureBasedRaise(propertyPartData)) {
              for (let i = 0; i < propertyPartState.hasRaisedFloor.length; i++) {
                propertyPartState.hasRaisedFloor[i] = true;
              }
            }

          }

        }
      }

      let nextRoundText = "";
      let reportText;
      let analyticsText;

      if (seaVote) {
        nextRoundText = this.pickText("choice_8_tui_next_round_marae", "choice_6_dara_next_round_farm", "choice_5_dara_next_round_town");
        reportText = T("built_nature_sea_report");
        analyticsText = "Nature based (sea) built";
      }
      else {
        nextRoundText = this.pickText("choice_7_tui_next_round_marae", "choice_5_dara_next_round_farm", "choice_4_dara_next_round_town");
        reportText = T("built__nature_river_report");
        analyticsText = "Nature based (river) built";
      }

      doPlayerAction(playerState, reportText, analyticsText, maxRounds);

      if (seaVote) {
        playerState.natureBasedSeaSolution = true;
        playerState.seaWallHeight = 0;
      }
      else {
        playerState.isMakingNatureBasedSolution = true;
        playerState.stopBank = false;
      }

      this.updateGame();
      this.setDefaultText(nextRoundText);

    },

    //helper method to simplify showing different text to different kinds of players
    pickText(maraeKey: string, farmKey: string, townshipKey: string): string {

      if (this.isMarae) {
        return T(maraeKey);
      }
      else if (this.isFarm) {
        return T(farmKey);
      }
      return T(townshipKey);

    },


    stopBankEveryoneAgreed() {

      //Stop bank vote height height must be set first
      this.powerupCount++;

      let game = this.game;
      let playerState = this.playerState;

      if (!playerState || !game) {
        return;
      }

      let nextRoundText: string;
      let reportText: string;

      switch (this.stopBankVoteType) {
        case 2: //two layer seawall
          nextRoundText = this.pickText("choice_10_tui_next_round_marae", "choice_8_dara_next_round_farm", "choice_7_dara_next_round_town");
          reportText = T("built_seawall_2_report");

          break;
        case 1: //One layer seawall
          nextRoundText = this.pickText("choice_9_tui_next_round_marae", "choice_7_dara_next_round_farm", "choice_6_dara_next_round_town");
          reportText = T("built_seawall_1_report");
          break;

        default: //stop bank
          nextRoundText = this.pickText("choice_6_tui_next_round_marae", "choice_4_tui_next_round_farm", "choice_3_tui_next_round_town");
          reportText = T("built_stopbank_report");
          break;
      }

      //For OUR player only, subtract the stop bank cost
      playerState.bankBalance -= getStopBankCost(playerState, this.stopBankVoteType, false, game.governmentSubsidy);
      let analyticsText: string;

      if (this.stopBankVoteType == 0) {

        playerState.stopBank = true;

        //Destroy the river nature based solution
        playerState.isMakingNatureBasedSolution = false;
        playerState.natureBasedState = 0;
        analyticsText = "Stop bank built";

      }
      else {
        playerState.natureBasedSeaSolution = false; //Destroy the nature based sea solution
        if (playerState.seaWallHeight == 0) {
          //If we're making a NEW seawall, put it at this round
          playerState.seaWallRound = Math.max(1, this.round);
        }
        playerState.seaWallHeight += this.stopBankVoteType;
        analyticsText = "Seawall built to level " + playerState.seaWallHeight;
      }

      doPlayerAction(playerState, reportText, analyticsText, maxRounds);
      this.updateGame();

      this.setDefaultText(nextRoundText);

    },

    //Overrides the default text for the next round - AND this one
    setDefaultText(text: string, force = true) {

      for (let i = 0; i < 2; i++) {
        const targetRound = this.round + i;

        if (this.newDefaultText.length > targetRound) {
          if (force || !this.newDefaultText[targetRound]) {
            this.newDefaultText[targetRound] = text;
          }
        }
      }



    },

    updateGame(start = false) {

      if (!this.game) {
        return;
      }

      const updateObject = {};

      //Only the host gets to update the core state
      if (this.isHost) {
        updateObject["gamestate"] = this.game.gamestate;
        updateObject["governmentSubsidy"] = this.game.governmentSubsidy;
        updateObject["riverStates"] = this.game.riverStates;
        updateObject["stormStates"] = this.game.stormStates;
      }

      //Only update the local player, unless we're starting the game
      if (start) {

        updateObject["playerStates"] = this.game.playerStates;

      }
      else {

        const myUserId = getUserId(this.game, this.myUUID)
        const state = this.game.playerStates[myUserId];
        if (state) {
          updateObject["playerStates/" + myUserId] = state;
        }

      }

      if (this.offline) {

        this.onGameUpdated(this.game);

      }
      else {

        //Update the main game
        this.syncroniseDB(updateObject);
      }

    },

    syncroniseDB(updateObject: object) {

      if (!this.game) {
        return;
      }

      update(ref(database, gamePath(gameType.futureCostsAotearoa, this.game.id)), updateObject);
    },

    isMessageProcessed(key: string): boolean {

      if (this.processedMessages[key]) {
        return true;
      }

      this.processedMessages[key] = true;
      return false;

    },

    get<T>(url: string, load: boolean): Promise<T | null> {

      return new Promise<T | null>((resolve, reject) => {

        if (load) {
          this.loadingCounter++;
        }

        axios.get<FirebaseResult<T>>(url)
          .then((result) => {

            if (result.data.success) {
              resolve(result.data.data);
            }
            else {
              reject(result.data.message);
            }


          })
          .catch(reject).finally(() => {
            if (load) {
              this.loadingCounter--;
            }
          });

      })

    },

    createSession(): void {

      this.get<Game>(api_getGameId + "/" + this.myUUID, true).then((result) => {

        if (result) {
          this.joinGame(result.id);
        }

      })
        .catch((msg) => this.setGameOver("Error", msg, false));

    },

    sendMessage(messageEvent: MessageEvent): void {

      if (!this.game) {
        return;
      }

      axios.post(api_Game + "/" + this.game.id + "/Message", new message(this.myUUID, messageEvent.detail[0].content))
        .catch((msg) => this.setGameOver("Error", msg, false));

    },

    joinGame(gameId: string | null): void {

      if (gameId) {
        this.joinedGame = gameId;
      }

      if (!gameId) {
        return;
      }

      this.joinError = "";

      this.get<Game>(api_Game + "/" + gameId + "/Join/" + this.myUUID, true).then((game) => {

        this.joinedMultiplayerGame = true;

        //Replace the URL
        const newUrl = window.location.href.split("?")[0] + "?id=" + gameId;
        window.history.replaceState(null, '', newUrl);

        this.offline = false;

        if (!game) {
          return;
        }

        this.game = game;

        if (this.isHost) {
          this.AppState = appStates.sessionCode;
        }
        else {
          this.AppState = appStates.game;
        }

        onValue(ref(database, gamePath(gameType.futureCostsAotearoa, gameId)), (update) => {
          if (this.joinedMultiplayerGame == false) {
            return;
          }

          this.onGameUpdated(update.val())
        });

      }).catch((error: string) => {

        error = error.replace("Error: ", "").trim();

        if (this.AppState == this.AppStates.joinSession) {

          this.clearQueryString();
          this.failedToJoinSession(error);

        }
        else {
          this.setGameOver("Error", error, false);
        }

      });

    },

    failedToJoinSession(error: string) {

      //Failed to join a session
      if (!Dictionary) {
        setTimeout(() => {
          this.failedToJoinSession(error);
        }, 1000);
        return;
      }

      if (Dictionary[error]) {
        error = T(error);
      }
      this.joinError = error;

    },

    onGameUpdated(game: Game): void {

      //Fix player states, Firebase conversion...
      if (game.playerStates) {
        const playerStates: { [id: string]: playerState } = {};
        for (const key of Object.keys(game.playerStates)) {
          const value = game.playerStates[key];
          if (value) {
            playerStates[key] = value;
          }
        }
        game.playerStates = playerStates;
      }

      this.messages = repairChat(game, T);

      //New messages?
      if (this.messageCount < this.messages.length) {
        this.messageCount = this.messages.length;
        this.showChat = true;
      }

      this.game = game;
      this.GameState = this.game.gamestate;
      this.mainGameUpdates++;

      if (this.GameState == gamestates.Game) {
        this.clearQueryString();
      }

      const playerId = getUserId(this.game, this.myUUID);
      const playerState = playerId && this.game && this.game.playerStates ? this.game.playerStates[playerId] : null;
      //      let requiredVotes = 0;

      //Are we at the end of the round? Only the host PC gets to update to next round
      if (this.isHost && this.game) {

        /*
        if (allPlayersAtState(this.game, roundstates.FinishedRound)) {
          progressToNextRound(this.game);
          this.updateGame();
          return;
        }
        */

        if (game.gameCommands) {
          for (const key of Object.keys(game.gameCommands)) {
            const command = game.gameCommands[key];

            if (!this.isMessageProcessed(key)) {

              switch (command.CommandType) {

                case GameCommandTypes.RequestVoteOnStopBank:

                  //Need to send a message to every player that a request to vote on stop bank has been received
                  this.sendRPCToAll(playerRPCType.AskForStopBankVote, command.Value);

                  //Also reset the list of votes that we've received from previous rounds etc
                  this.votes = {};
                  break;

                case GameCommandTypes.RequestVoteOnNatureBased:

                  //Need to send a message to every player that can vote that a vote has been received                  
                  /*
                  for (const key of Object.keys(this.game.playerStates)) {
                    if (getNatureBasedCost(this.game.playerStates[key], false, this.game.governmentSubsidy)) {
                      this.sendRPCToPlayer(key, playerRPCType.AskForNatureBasedVote, command.Value);
                    }
                  }*/

                  this.sendRPCToAll(playerRPCType.AskForNatureBasedVote, command.Value);

                  //Also reset the list of votes that we've received from previous rounds etc
                  this.votes = {};
                  break;

                case GameCommandTypes.VoteOnNatureBased:

                  this.votes[command.UUID] = command.Value;

                  //We've got every vote
                  if (Object.keys(this.votes).length >= Object.keys(this.game.playerStates).length) {

                    let result: voteResults = {
                      yesVotes: 0,
                      noVotes: 0,
                    }

                    for (const vote of Object.values(this.votes)) {
                      if (vote) {
                        result.yesVotes++;
                      }
                      else {
                        result.noVotes++;
                      }
                    }

                    this.sendRPCToAll(playerRPCType.NatureBasedVoteFinished, result);
                  }

                  break;

                case GameCommandTypes.VoteOnStopBank:

                  this.votes[command.UUID] = command.Value;

                  //We've got every vote
                  if (Object.keys(this.votes).length >= Object.keys(this.game.playerStates).length) {

                    let result: voteResults = {
                      yesVotes: 0,
                      noVotes: 0,
                    }

                    for (const vote of Object.values(this.votes)) {
                      if (vote) {
                        result.yesVotes++;
                      }
                      else {
                        result.noVotes++;
                      }
                    }
                    this.sendRPCToAll(playerRPCType.StopBankVoteFinished, result);

                  }
                  break;

              }
            }

          }
        }
      }

      let updateNeeded = false;
      let donation: playerDonation;

      //Do we have any unprocessed RPC messages
      if (playerState && playerState.playerRPC) {
        for (const key of Object.keys(playerState.playerRPC)) {
          const rpc = playerState.playerRPC[key];
          if (!this.isMessageProcessed(key)) {

            this.processedMessages[key] = true;

            switch (rpc.RPCType) {

              case playerRPCType.Donate:

                donation = rpc.Value;
                this.game.playerStates[this.user].bankBalance += donation.amount;
                this.donationReceivedList.push(donation);
                updateNeeded = true;
                break;

              case playerRPCType.AskForStopBankVote:
                this.stopBankVoteRequested = true;
                this.stopBankVoteType = rpc.Value;
                break;

              case playerRPCType.AskForNatureBasedVote:
                this.natureBasedVoteRequested = true;
                this.natureBasedVoteType = rpc.Value;
                break;

              case playerRPCType.StopBankVoteFinished:
                this.waitingForStopBankResult = false;
                if (this.processVoteResults(false, rpc.Value)) {
                  this.stopBankEveryoneAgreed();
                  updateNeeded = true;
                }
                break;

              case playerRPCType.NatureBasedVoteFinished:
                this.waitingForNatureBasedResult = false;
                if (this.processVoteResults(true, rpc.Value)) {
                  this.natureBasedEveryoneAgreed();
                  updateNeeded = true;
                }
                break;

            }

          }
        }
      }

      //If the round has increased, reset our player position
      if (this.GameState == gamestates.Game && playerState && playerState.round > this.localRound) {

        this.localRound = playerState.round;

        if (playerState.round >= maxRounds) {
          this.setGameOver(T("gameover"), T("gameover_10rounds"), true);
          return;
        }

        playerState.roundState = roundstates.Storm;
        prepareRound(this.game, this.myUUID, this.offline);
        updateNeeded = true;

      }

      if (updateNeeded) {
        this.updateGame();
      }

    },

    processVoteResults(isNatureBased: boolean, result: voteResults): boolean {
      this.yesVotes = result.yesVotes;
      this.noVotes = result.noVotes;
      this.showNatureBasedResult = isNatureBased;
      this.showStopBankResult = !isNatureBased;

      //Only a successful vote if passed unanimously
      return result.noVotes == 0;
    },

    clearQueryString() {
      //Don't clear the query string
      if (window.location.href.indexOf("?") == -1) {
        return;
      }
      window.history.replaceState(null, '', window.location.href.split("?")[0]);
    },

    setGameOver(header: string, message: string, askForFeedback: boolean) {

      if (this.gameOverMessage) {
        return; //We've already reached the game over state
      }

      this.joinedMultiplayerGame = false;
      this.clearQueryString();

      this.askForFeedback = askForFeedback;
      this.gameOverHeader = header;
      this.gameOverMessage = message;
    },

    sendCommand(commandType: GameCommandTypes, value: boolean | null | number) {

      if (!this.game) {
        return;
      }

      push(ref(database, gamePath(gameType.futureCostsAotearoa, this.game.id) + "/gameCommands"), new GameCommand(commandType, this.myUUID, value));

    },

    sendRPCToAll(type: playerRPCType, value: boolean | null | voteResults) {

      if (!this.game) {
        return;
      }

      for (const playerKey of Object.keys(this.game.playerStates)) {
        this.sendRPCToPlayer(playerKey, type, value);
      }

    },

    sendRPCToPlayer(playerKey: string, type: playerRPCType, value: boolean | number | null | voteResults | playerDonation) {

      if (!this.game) {
        return;
      }

      push(ref(database, gamePath(gameType.futureCostsAotearoa, this.game.id) + "/playerStates/" + playerKey + "/playerRPC"), new playerRPC(type, value));

    },

    resized(): void {

      requestAnimationFrame(this.resized);

      const gameWindow = document.getElementById("window");
      if (!gameWindow) {
        return;
      }

      const newPx_ratio =
        window.devicePixelRatio || window.screen.availWidth / window.innerWidth;

      let zoomScale = newPx_ratio / this.px_ratio;

      let scale = window.innerHeight / referenceHeight;
      let totalScale = scale * zoomScale;

      document.documentElement.style.setProperty("--zoom-scale", totalScale.toString());

      let newWidth = "";

      if (window.innerWidth > window.innerHeight) {
        newWidth = window.innerWidth / scale + "px";
      } else {
        const adjustedHeight = window.innerHeight / scale;
        newWidth = adjustedHeight * (referenceWidth / referenceHeight) + "px";
      }

      document.documentElement.style.setProperty("--aspect-ratio-too-small-width", (window.innerWidth / scale) + "px");

      //Have we actually resized?
      if (newWidth != lastWidth) {
        gameWindow.style.width = newWidth;
        lastWidth = newWidth;
        this.mainGameUpdates++; //Force everything to refresh
      }

    },

  }
});


export interface playerViewState {
  id: string;
  takingTurn: boolean;
}

export function roundedValue(value: number, usesDivider = false): string {

  const divider = usesDivider ? "|" : "";

  if (value <= 0 && usesDivider) {
    return "✓";
  }
  if (value >= 1000) {
    return divider + "$" + (value / 1000) + "M";
  }

  return divider + "$" + value + "K";
}

</script>


<style lang="less" scoped>
.title-btn {
  width: 167px;
  height: 35px;
  top: 11px;
  left: 27px;
  position: absolute;
  background-image: url("./assets-fca/UI/title.svg");
  cursor: pointer;
}

.audio-btn {
  background-image: url("./assets-fca/UI/audio_on.svg");
  position: absolute;
  width: 29px;
  height: 29px;
  top: 15px;
  right: 57px;
  cursor: pointer;
  z-index: 500;
}

.audio-muted {
  .audio-btn;
  background-image: url("./assets-fca/UI/audio_muted.svg");
}

.chat {
  .audio-btn;
  background-image: url("./assets-fca/UI/chat.svg");
  right: 98px;
}

.chat-opened {
  .chat;
  background-image: url("./assets-fca/UI/chat_opened.svg");
}

.hamburger-btn {
  .audio-btn;
  background-image: url("./assets-fca/UI/hamburger.svg");
  right: 16px;
}

.preload-base {
  pointer-events: none;
  opacity: 0;
}

.preload-rubik {
  font-family: rubik;
}

.preload-rubik-500 {
  font-weight: 500;
}

.preload-rubik-700 {
  font-weight: 700;
}

.preload-rubik-800 {
  font-weight: 800;
}

.preload-rubik-900 {
  font-weight: 900;
}


.yes-button {
  height: 40px;
  width: 100px;
  border-radius: 8px;
  background-color: #B2CD30;
  color: #636252;
  font-family: Rubik;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
  height: 40px;
  width: 100px;
  position: absolute;
  top: 239px;
  left: 50%;
  margin-left: -120px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}


.no-button {
  height: 40px;
  width: 100px;
  border-radius: 8px;
  background-color: #007D8D;
  color: #FFFFFF;
  font-family: Rubik;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
  left: 50%;
  margin-left: 20px;
  top: 239px;
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<!-- non scoped version -->
<style lang="less">
ul {
  margin-bottom: 0;
}

.v-toast__item--info {
  background-color: #B2CD30 !important;
}

.icon-bank-balance {
  background: url('./assets-fca/UI/icon_bank_balance.svg');
  background-size: contain;
}

.icon-government {
  background: url('./assets-fca/UI/icon_government.svg');
  background-size: contain;
}

.blank-background {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #5f8b9c;
}

.force-to-front {
  z-index: 999 !important;
}

.font-weight-bold {
  font-weight: bold;
}

.inner-content-scaled-down {
  transform: scale(0.9230769230769231);
}

.blur {
  backdrop-filter: blur(10px);
}

.bank-balance-container {
  position: absolute !important;
  top: 10px;
  left: 24px;
}

.foreground {
  z-index: 100;
}

.upper-panel {
  height: 87px;
  margin-top: 160px;
}

.game-mode-text {
  margin-top: 33.54px;
  height: 61px;
}

.game-mode-text-lower {
  font-size: 30px;
  line-height: 36px;
}


.game-mode-button {
  width: 355px;
  height: 419px;
  cursor: pointer;
  color: #FFFFFF;
  font-family: Rubik;
  font-size: 38px;
  letter-spacing: 0;
  line-height: 46px;
  text-align: center;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}

#app {
  .noselect;
  font-family: Rubik;
  white-space: pre-line;
  transform-origin: top;
}

#windowWrapper {
  height: 0px;
}

#window {
  width: 100%;
  height: 832px; //1024
  transform-origin: top left;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  position: relative;
  transform: scale(var(--zoom-scale))
}

.outer-content {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.inner-content {
  width: 1067px; //
  height: 100%;
  position: relative;
}

.header {
  color: #FFFFFF;
  font-family: Rubik;
  font-size: 60px;
  letter-spacing: 0;
  line-height: 71px;
  text-align: center;
}

.rectangle {
  box-sizing: border-box;
  height: 335px;
  width: 335px;
  border: 12px solid #4A4A4A;
  border-radius: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-container {
  top: 285px;
}

.button-container-inner {
  width: 800px;
}

.caravan {
  background: url("./assets-fca/Active Properties/caravan.svg");
}

.house-blue {
  background: url("./assets-fca/Active Properties/house_blue.svg");
}

.house-blue-raised {
  background: url("./assets-fca/Active Properties/house_blue_raised.svg");
}

.house-orange {
  background: url("./assets-fca/Active Properties/house_orange.svg");
}

.house-orange-raised {
  background: url("./assets-fca/Active Properties/house_orange_raised.svg");
}

.safe-house-lifestyle {
  background: url("./assets-fca/Active Properties/safe-house-lifestyle.svg");
}

.safe-house-luxury {
  background: url("./assets-fca/Active Properties/safe-house-luxury.svg");
}

.medium-family-home {
  background: url("./assets-fca/Active Properties/medium_family_home.svg");
}

.medium-family-home-raised {
  background: url("./assets-fca/Active Properties/medium_family_home_raised.svg");
}

.medium-family-home-teal {
  background: url("./assets-fca/Active Properties/medium_family_home_teal.svg");
}

.medium-family-home-teal-raised {
  background: url("./assets-fca/Active Properties/medium_family_home_teal_raised.svg");
}

.farm-house {
  background: url("./assets-fca/Active Properties/farm_house.svg");
}

.farm-house-raised {
  background: url("./assets-fca/Active Properties/farm_house_raised.svg");
}

.cow-shed {
  background: url("./assets-fca/Active Properties/cow_shed.svg");
}

.cow-shed-damaged {
  background: url("./assets-fca/Active Properties/cow_shed_damaged.svg");
}

.farm-outline-1 {
  background: url("./assets-fca/Boundary Lines/farm_outline_1.svg");
}

.farm-outline-2 {
  background: url("./assets-fca/Boundary Lines/farm_outline_2.svg");
}

.farm-outline-atrisk-1 {
  background: url("./assets-fca/Boundary Lines/farm_outline_atrisk_1.svg");
}

.farm-outline-atrisk-2 {
  background: url("./assets-fca/Boundary Lines/farm_outline_atrisk_2.svg");
}

.townsperson-outline-1 {
  background: url("./assets-fca/Boundary Lines/townsperson_outline_1.svg");
}

.townsperson-outline-2 {
  background: url("./assets-fca/Boundary Lines/townsperson_outline_2.svg");
}

.lifestyle-outline {
  background: url("./assets-fca/Boundary Lines/lifestyle_outline.svg");
}

.luxury-outline {
  background: url("./assets-fca/Boundary Lines/luxury_outline.svg");
}

.lowrisk-outline {
  background: url("./assets-fca/Boundary Lines/lowrisk_outline.svg");
}

.family-outline {
  background: url("./assets-fca/Boundary Lines/family_outline.svg");
}

.atrisk-outline {
  background: url("./assets-fca/Boundary Lines/atrisk_outline.svg");
}

.marae-outline {
  background: url("./assets-fca/Boundary Lines/marae_outline.svg");
}

.water-pump {
  background: url("./assets-fca/Active Properties/water-pump.gif");
}

.wharenui {
  background: url("./assets-fca/Active Properties/wharenui.svg");
}

.wharenui-raised {
  background: url("./assets-fca/Active Properties/wharenui_raised.svg");
}

.wharekai {
  background: url("./assets-fca/Active Properties/wharekai.svg");
}

.urupa {
  background: url("./assets-fca/Active Properties/urupa.svg");
}

.urupa-moving {
  background: url("./assets-fca/Active Properties/urupa_moving.svg");
}

.papakainga {
  background: url("./assets-fca/Active Properties/papakainga.svg");
}

.papakainga-raised {
  background: url("./assets-fca/Active Properties/papakainga_raised.svg");
}

.townsperson1-game-piece {
  background: url('./assets-fca/Avatars/avatarAshTab.svg');
}

.townsperson2-game-piece {
  background: url('./assets-fca/Avatars/avatarNyahTab.svg');
}

.farmer1-game-piece {
  background: url('./assets-fca/Avatars/avatarTrevTab.svg');
}

.farmer2-game-piece {
  background: url('./assets-fca/Avatars/avatarGraceTab.svg');
}

.komatua-game-piece {
  background: url('./assets-fca/Avatars/avatarPaniaTab.svg');
}

.sign-1000-k {
  background: url('./assets-fca/Signs/sign-1000-k.svg');
}

.sign-1000-k-disabled {
  background: url('./assets-fca/Signs/sign-1000-k-disabled.svg');
}

.sign-1000-k-selected {
  background: url('./assets-fca/Signs/sign-1000-k-selected.svg');
}

.sign-1200-k {
  background: url('./assets-fca/Signs/sign-1200-k.svg');
}

.sign-1200-k-disabled {
  background: url('./assets-fca/Signs/sign-1200-k-disabled.svg');
}

.sign-1200-k-selected {
  background: url('./assets-fca/Signs/sign-1200-k-selected.svg');
}

.sign-2000-k {
  background: url('./assets-fca/Signs/sign-2000-k.svg');
}

.sign-2000-k-disabled {
  background: url('./assets-fca/Signs/sign-2000-k-disabled.svg');
}

.sign-2000-k-selected {
  background: url('./assets-fca/Signs/sign-2000-k-selected.svg');
}

.sign-3000-k {
  background: url('./assets-fca/Signs/sign-3000-k.svg');
}

.sign-3000-k-disabled {
  background: url('./assets-fca/Signs/sign-3000-k-disabled.svg');
}

.sign-3000-k-selected {
  background: url('./assets-fca/Signs/sign-3000-k-selected.svg');
}

.elsewhere-500-k {
  background: url('./assets-fca/Signs/elsewhere-500-k.svg');
}

.elsewhere-500-k-disabled {
  background: url('./assets-fca/Signs/elsewhere-500-k-disabled.svg');
}

.elsewhere-500-k-selected {
  background: url('./assets-fca/Signs/elsewhere-500-k-selected.svg');
}

.elsewhere-2000-k {
  background: url('./assets-fca/Signs/elsewhere-2000-k.svg');
}

.elsewhere-2000-k-disabled {
  background: url('./assets-fca/Signs/elsewhere-2000-k-disabled.svg');
}

.elsewhere-2000-k-selected {
  background: url('./assets-fca/Signs/elsewhere-2000-k-selected.svg');
}

.game-over {
  font-family: Rubik;
  font-size: 30px;
  font-weight: 800;
  line-height: 35.55px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #636252;
  margin-top: 20px;
}

.game-over-text {
  margin-top: 10.2px;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.59px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #333333;
  width: 100%;
  padding-left: 155px;
  padding-right: 155px;
}

.game-over-feedback-prompt {
  font-family: Rubik;
  font-size: 16px;
  font-weight: 800;
  line-height: 18.96px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #636252;
  position: absolute;
  width: 332px;
  left: 596px;
  top: 327px;
}

.game-over-btn {
  position: absolute;
  top: 563px;
  border-radius: 8px;
  left: 596px;
  background-color: #F1A738;
  width: 162px;
  height: 50px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Rubik;
  font-size: 14px;
  font-weight: 800;
  line-height: 16.59px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  cursor: pointer;
}

.game-over-btn-2 {
  .game-over-btn;
  left: 768px;
  background-color: #B2CD30;
}

.game-over-dashboard-header {
  position: absolute;
  top: 30px;
  left: 743px;
}

.auto-center {
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.btn-base {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}

.tutorial-cover {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1;
  pointer-events: none;
}

.no-thanks-button {
  height: 40px;
  width: 110px;
  border-radius: 8px;
  border-style: none;
  background-color: #007D8D;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}


.confirm-button {
  height: 40px;
  width: 110px;
  border-radius: 8px;
  border-style: none;
  background-color: #B2CD30;
  color: #636252;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  text-align: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-button-disabled {
  .confirm-button;
  opacity: 0.5;
  pointer-events: none;
  cursor: default;
}

.shared-back-button {
  border-radius: 8px;
  background-color: #F1A738;
  width: 162px;
  height: 50px;
  position: absolute;
  left: 77px;
  top: 725px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Rubik;
  font-weight: 700;
  font-size: 14px;
  line-height: 16.59px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
}

.shared-back-button-dialogue {
  .shared-back-button;
  left: 128px;
  bottom: 64px;
  top: unset;
}

.shared-continue-button-dialogue {
  .shared-back-button-dialogue;
  right: 128px;
  left: unset;
  background-color: #B2CD30;
}

.yes-click {
  pointer-events: auto;
}

.no-click {
  pointer-events: none;
  cursor: default;
}

.game-over-feedback-field {
  position: absolute;
  width: 334px;
  height: 171px;
  top: 373px;
  left: 596px;
  border-radius: 13px;
  border: 1.5px solid;
  border-color: #D9D9D9;
}

.game-over-avatar-circle {
  position: absolute !important;
  top: 144px;
  left: 599px;
}

.game-over-round-container {
  position: absolute;
  width: 526px;
  height: 467.35px;
  left: 47px;
  top: 141px;
}

.game-over-round-inner {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 24px;
}

.game-over-round-label {
  color: #007D8D;
  font-family: Rubik;
  font-weight: 800;
  font-size: 16.42px;
  line-height: 19.45px;
  letter-spacing: 0px;
  text-align: center;
  position: absolute;
  left: 1.33px;
  top: 3.61;
}

.game-over-river-label {
  .game-over-round-label;
  left: 381.34px;
}

.game-over-ocean-label {
  .game-over-round-label;
  left: 447.72px;
}

.facilitator {
  background: url("./assets-fca/Guide/facilitator.svg");
}

.facilitator-game-over {
  width: 270px;
  height: 344px;
  position: absolute;
  top: 325px;
  left: -206px;
  z-index: -1;
}

.facilitator-tick {
  background-image: url("./assets-fca/Guide/facilitator-tick.svg");
  position: absolute;
  background-size: cover;
  width: 51px;
  height: 51px;
}

.facilitator-tick-game-over {
  top: 300px;
  left: -53px;
  rotate: -90deg;
  width: 94px;
  height: 94px;
}

.quit-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.quit-header {
  margin-top: 34px;
  font-family: Rubik;
  font-weight: 800;
  font-size: 30px;
  line-height: 35.55px;
  letter-spacing: 0px;
  color: #636252;
}

.quit-text {
  margin-top: 49px;
  font-family: Rubik;
  font-weight: 400;
  font-size: 16px;
  line-height: 18.96px;
  letter-spacing: 0px;
  text-align: center;
  color: #333333;
}

.quit-yes-button {
  width: 162px;
  height: 50px;
  position: absolute;
  top: 204px;
  left: 168px;
  color: white;
  background-color: #B2CD30;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  font-family: Rubik;
  font-weight: 800;
  font-size: 14px;
  line-height: 16.59px;
  letter-spacing: 0%;
}

.quit-no-button {
  .quit-yes-button;
  left: unset;
  right: 168px;
  background-color: #F1A738;
}

.aspect-ratio-correct-container {
  position: absolute;
  width: 100%;
  height: 100%;
}

.aspect-ratio-warning-button {
  .game-over-btn-2;
  position: unset;
  margin-top: 20px;
}

.aspect-ratio-warning-header {
  font-family: Rubik;
  font-weight: 800;
  font-size: 30px;
  line-height: 35.55px;
  letter-spacing: 0px;
  color: #636252;
}

.aspect-ratio-warning-text {
  font-family: Rubik;
  font-weight: 400;
  font-size: 16px;
  line-height: 18.96px;
  letter-spacing: 0px;
  color: #333333;
  margin-top: 20px;
}

.aspect-ratio-warning-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
}

.hamburger-menu-container {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(41, 46, 68, 0.5);
  z-index: 2000;
}

.hamburger-menu {
  height: 100%;
  width: 549px;
  right: 0px;
  position: absolute;
  background-color: #292E44;
}

.hamburger-close-btn {
  background-image: url("./assets-fca/UI/close.svg");
  width: 24px;
  height: 24px;
  position: absolute;
  top: 20px;
  right: 18px;
  cursor: pointer;
}

.aspect-ratio-close-btn{
  .hamburger-close-btn;
  background-size: cover;
  background-image: url("./assets-fca/UI/close_gray.svg");
}

.hamburger-logo {
  background-image: url("./assets-fca/UI/hamburger_logo.svg");
  position: absolute;
  top: 43px;
  left: 82px;
  width: 179px;
  height: 37px;
}

.hamburger-menu-text-container {
  position: absolute;
  top: 170px;
  left: 84px;
  width: 331px;
}

.hamburger-menu-text-container div {
  font-family: Rubik;
  color: white;
  margin-bottom: 24px;
}

.hamburger-menu-text-container a {
  font-family: Rubik;
  color: white;
  margin-bottom: 24px;
}

.hamburger-menu-header {
  font-family: Rubik;
  font-weight: 500;
  font-size: 15px;
  line-height: 17.78px;
  letter-spacing: 0.02px;
  height: 18px;
}

.hamburger-menu-link-btn {
  display: block;
  cursor: pointer;
  font-weight: 800;
  font-size: 24px;
  line-height: 28.44px;
  letter-spacing: 0.02px;
  height: 28px;
  text-decoration: none;
  color: white;
}

.hamburger-menu-header-divider {
  background-color: white;
  height: 1px;
  width: 179px;
}

.aspect-ratio-too-small {
  width: var(--aspect-ratio-too-small-width);
  height: 832px;
  position: absolute;
  z-index: 9999;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
